module.exports = __webpack_public_path__ + "img/Trophy.6299b748.jpg";